import { render } from "./Service_home.vue?vue&type=template&id=c3925fac&scoped=true"
import script from "./Service_home.vue?vue&type=script&lang=js"
export * from "./Service_home.vue?vue&type=script&lang=js"

import "./Service_home.vue?vue&type=style&index=0&id=c3925fac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3925fac"]])

export default __exports__